export default __webpack_public_path__ + "Montserrat-Regular.ttf?2a2d37bf7680d86811db09a7b7177b47";